











































































import { Vue, Component, Prop } from 'vue-property-decorator'

import DesktopsStoreModule from '../store/DesktopsStoreModule'

import CoreStoreModule from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import OrganizationNavigator from '@revas/kadra-library/src/revas/vue/vue-router/OrganizationNavigator'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import { App, SystemInfo } from '@/models'

import AppAppCard from '@/components/homepage/AppAppCard.vue'
import AppAppContextualMenu from '@/components/homepage/AppAppContextualMenu.vue'
import AppAppsDrawer from '@/components/homepage/AppAppsDrawer.vue'
import AppHomepageFrame from '@/components/homepage/AppHomepageFrame.vue'
import User from '@revas/kadra-library/src/revas/vue/vuex/models/User'

@Component({
  components: {
    AppAppCard,
    AppAppContextualMenu,
    AppAppsDrawer,
    AppHomepageFrame
  }
})
export default class VAppsCollection extends Vue {
  @Prop() readonly desktopsStoreModule!: DesktopsStoreModule
  @Prop() readonly appStoreModule!: AppStoreModule
  @Prop() readonly coreStoreModule!: CoreStoreModule
  @Prop() organizationId!: string
  @Prop() navigator!: OrganizationNavigator
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly router!: VueRouter
  @Prop() readonly routeName!: string
  @Prop() systemInfo!: SystemInfo

  created () {
    this.desktopsStoreModule.asyncListApps()
  }

  availableCells = 0

  get desktopApps () {
    return this.apps.filter(a => a.positionY !== 0)
  }

  get maxCells (): number {
    return this.desktopApps.length + this.availableCells
  }

  get apps (): App[] {
    const a = this.desktopsStoreModule.apps
    if (a === null) {
      return []
    } else {
      return a
    }
  }

  get orderedApps (): App[] {
    return this.apps.filter(a => a.positionY !== 0).sort(function (a: App, b: App) { return a.positionY - b.positionY })
  }

  isDraggingActive = false

  getAppByOrder (position: number): App | null {
    if (position > this.orderedApps.length) {
      return null
    }
    const foundApp: App = this.orderedApps[position - 1]
    return foundApp === undefined ? null : foundApp
  }

  startDrag (evt: DragEvent, app: App, cells: number) {
    this.availableCells = cells
    this.isDraggingActive = true
    if (evt !== null && evt.dataTransfer !== null) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('appId', app.id)
      console.log(app.id, cells)
    }
  }

  async listApps () {
    await this.desktopsStoreModule.asyncListApps()
  }

  async updateApp (app: App) {
    await this.desktopsStoreModule.asyncUpdateApp(
      {
        app: app
      }
    )
    this.listApps()
  }

  onDrop (evt: DragEvent, order: number) {
    this.isDraggingActive = false
    if (evt !== null && evt.dataTransfer !== null) {
      const appId = evt.dataTransfer.getData('appId')
      const foundApp = this.apps.find(app => app.id === appId)
      if (foundApp !== undefined) {
        const updatedApp: App = {
          id: foundApp.id,
          name: foundApp.name,
          title: foundApp.title,
          description: foundApp.description,
          url: foundApp.url,
          icon: foundApp.icon,
          organizationId: foundApp.organizationId,
          userId: foundApp.userId,
          packageName: foundApp.packageName,
          positionY: order
        }
        this.updateApp(updatedApp)
      }
      this.listApps()
    }
  }

  isDrawerVisible = false

  isShowingInstalledApps = false
  showInstalledApps () {
    this.isShowingInstalledApps = !this.isShowingInstalledApps
    setTimeout(() => {
      this.isDrawerVisible = !this.isDrawerVisible
    }, 1000)
  }

  isShowingAppMenu = false

  appMenuStyle = ''

  rightClickedApp: App | null = null

  openMenu (e: any, app: App) {
    e.preventDefault()
    this.isShowingAppMenu = !this.isShowingAppMenu
    const top = e.clientY
    const left = e.clientX
    const maxHeight = window.innerHeight
    const maxWidth = window.innerWidth
    console.log(top, left)
    if (top > maxHeight - 250) {
      if (left > maxWidth - 200) {
        this.appMenuStyle = `bottom: ${maxHeight - top}px; right: ${maxWidth - left}px;`
      } else {
        this.appMenuStyle = `bottom: ${maxHeight - top}px; left: ${left}px;`
      }
    } else {
      if (left > maxWidth - 250) {
        this.appMenuStyle = `top: ${top}px; right: ${maxWidth - left}px;`
      } else {
        this.appMenuStyle = `top: ${top}px; left: ${left}px;`
      }
    }
    this.rightClickedApp = app
  }

  openApp (url: string) {
    window.open(url, '_blank')
  }

  openSupport () {
    window.open('https://support.revas.app/it/', '_blank')
  }

  isAppOnDesktop (position: number) {
    if (position === 0) {
      return false
    } else {
      return true
    }
  }

  removeFromDesktop (app: App) {
    const updatedApp: App = {
      id: app.id,
      name: app.name,
      title: app.title,
      description: app.description,
      url: app.url,
      icon: app.icon,
      organizationId: app.organizationId,
      userId: app.userId,
      packageName: app.packageName,
      positionY: 0
    }
    this.updateApp(updatedApp)
  }

  goToStore () {
    this.$router.push('s')
  }

  get user (): User {
    const u = this.coreStoreModule.userProfile
    return u === null ? new User() : u
  }

  async deleteApp (appId: string) {
    await this.desktopsStoreModule.asyncDeleteApp({
      appId: appId
    })
    this.desktopsStoreModule.asyncListApps()
    this.desktopsStoreModule.asyncListPackages()
  }
}
